import { put } from "redux-saga/effects";

import { UpdateUserMetadataResponse } from "redmond";
import { actions } from "../actions";
import { updateUserMetadata } from "../../../api/v0/user/updateUserMetadata";
import { staysFilterFtuxLocalStorageKey } from "./fetchHasSeenStaysFilterFtuxSaga";

export function* updateHasSeenStaysFilterFtuxSaga(
  action: actions.IUpdateHasSeenStaysFilterFtux
) {
  try {
    const res: UpdateUserMetadataResponse = yield updateUserMetadata({
      userMetadata: {
        hasSeenStayTypeVrFtux: action.hasSeenStaysFilterFtux,
      },
    });

    if (res.Response !== "Success") {
      throw new Error("Failed to update metadata");
    }

    if (action.hasSeenStaysFilterFtux) {
      localStorage.setItem(staysFilterFtuxLocalStorageKey, "true");
    }
    yield put(actions.setHasSeenStaysFilterFtux(action.hasSeenStaysFilterFtux));
  } catch (e) {
    console.error(e);
    // Allow the ftux popup to close if there was an error updating the metadata
    localStorage.setItem(staysFilterFtuxLocalStorageKey, "true");
    yield put(actions.setHasSeenStaysFilterFtux(true));
  }
}
